// @flow
import styled from "styled-components"

export const ReservationSuccessWrap = styled.div`
  display: flex;
  text-align: center;
  align-items: center;
  flex-direction: column;
  width: 28.5rem;
  margin: 10rem auto 0;

  svg {
    margin-bottom: 3rem;
  }
`



// WEBPACK FOOTER //
// ./src/modals/ReservationSuccess/styled.js